import { render } from "./propaganda.vue?vue&type=template&id=e37462ec&scoped=true"
import script from "./propaganda.vue?vue&type=script&lang=js"
export * from "./propaganda.vue?vue&type=script&lang=js"

import "./propaganda.vue?vue&type=style&index=0&id=e37462ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e37462ec"]])

export default __exports__